
export const statesData = [
    {
        name: "Andhra Pradesh",
        districts: [
            "Anantapur",
            "Chittoor",
            "East Godavari",
            "Guntur",
            "Krishna",
            "Kurnool",
            "Nellore",
            "Prakasam",
            "Srikakulam",
            "Visakhapatnam",
            "Vizianagaram",
            "West Godavari",
            "YSR Kadapa"
        ]
    },
    {
        name: "Arunachal Pradesh",
        districts: ["Tawang",
            "West Kameng",
            "East Kameng",
            "Papum Pare",
            "Kra Daadi",
            "Lower Subansiri",
            "Upper Subansiri",
            "West Siang",
            "East Siang",
            "Siang",
            "Changlang",
            "Longding",
            "Namsai",
            "Lower Dibang Valley",
            "Upper Dibang Valley",
            "Dibang Valley",
            "Anjaw"
        ]
    },
    {
        name: "Assam",
        districts: ["Baksa",
            "Barpeta",
            "Bongaigaon",
            "Cachar",
            "Chirang",
            "Darrang",
            "Dhemaji",
            "Dibrugarh",
            "Goalpara",
            "Golaghat",
            "Hailakandi",
            "Hojai",
            "Jorhat",
            "Kamrup Metropolitan",
            "Kamrup Rural",
            "Karbi Anglong",
            "Karimganj",
            "Kokrajhar",
            "Lakhimpur",
            "Majuli",
            "Morigaon",
            "Nagaon",
            "Nalbari",
            "Sivasagar",
            "Sonitpur",
            "South Salmara",
            "Tinsukia",
            "Udalguri",
            "West Karbi Anglong"
        ]
    },
    {
        name: "Bihar",
        districts: ["Araria",
            "Arwal",
            "Aurangabad",
            "Banka",
            "Bastar",
            "Begusarai",
            "Bhagalpur",
            "Bhojpur",
            "Buxar",
            "Darbhanga",
            "Gaya",
            "Gopalganj",
            "Jamui",
            "Jehanabad",
            "Kaimur",
            "Katihar",
            "Khagaria",
            "Kishanganj",
            "Lakhisarai",
            "Madhubani",
            "Munger",
            "Muzaffarpur",
            "Nalanda",
            "Nawada",
            "Purnia",
            "Rohtas",
            "Saran",
            "Sheikhpura",
            "Sheohar",
            "Sitamarhi",
            "Siwan",
            "Supaul",
            "Vaishali",
            "West Champaran"
        ]
    },
    {
        name: "Chhattisgarh",
        districts: ["Balod",
            "Baloda Bazar",
            "Balrampur",
            "Bastar",
            "Bemetara",
            "Bilaspur",
            "Dantewada",
            "Dhamtari",
            "Durg",
            "Gariaband",
            "Janjgir-Champa",
            "Jashpur",
            "Korba",
            "Koria",
            "Kanker",
            "Mungeli",
            "Narayanpur",
            "Raigarh",
            "Raipur",
            "Rajnandgaon",
            "Sukma",
            "Surguja",
            "Surajpur",
            "Janjgir"
        ]
    },
    {
        name: "Goa",
        districts: ["North Goa",
            "South Goa"
        ]
    },
    {
        name: "Gujarat",
        districts: ["Ahmedabad",
            "Amreli",
            "Anand",
            "Aravalli",
            "Banaskantha",
            "Bharuch",
            "Bhavnagar",
            "Botad",
            "Chhota Udepur",
            "Dahod",
            "Dang",
            "Gandhinagar",
            "Gir Somnath",
            "Jamnagar",
            "Junagadh",
            "Kutch",
            "Mahisagar",
            "Mehsana",
            "Narmada",
            "Navsari",
            "Panchmahal",
            "Patan",
            "Porbandar",
            "Rajkot",
            "Sabarkantha",
            "Surat",
            "Surendranagar",
            "Tapi",
            "Vadodara",
            "Valsad"
        ]
    },
    {
        name: "Haryana",
        districts: ["Ambala",
            "Bhiwani",
            "Faridabad",
            "Fatehabad",
            "Gurugram",
            "Hisar",
            "Jhajjar",
            "Jind",
            "Kaithal",
            "Karnal",
            "Mahendragarh",
            "Mewat",
            "Panchkula",
            "Panipat",
            "Rewari",
            "Rohtak",
            "Sirsa",
            "Sonipat",
            "Yamunanagar"
        ]
    },
    {
        name: "Himachal Pradesh",
        districts: ["Bilaspur",
            "Chamba",
            "Hamirpur",
            "Kangra",
            "Kinnaur",
            "Kullu",
            "Lahaul and Spiti",
            "Mandi",
            "Shimla",
            "Sirmaur",
            "Solan",
            "Una"
        ]
    },
    {
        name: "Jharkhand",
        districts: ["Bokaro",
            "Chatra",
            "Deoghar",
            "Dhanbad",
            "Dumka",
            "East Singhbhum",
            "Garhwa",
            "Giridih",
            "Godda",
            "Gumla",
            "Hazaribagh",
            "Jamtara",
            "Khunti",
            "Koderma",
            "Latehar",
            "Lohardaga",
            "Pakur",
            "Palamu",
            "Ranchi",
            "Sahebganj",
            "Seraikela-Kharsawan",
            "Simdega",
            "West Singhbhum"
        ]
    },
    {
        name: "Karnataka",
        districts: ["Bagalkot",
            "Bangalore Rural",
            "Bangalore Urban",
            "Belagavi",
            "Bellary",
            "Bidar",
            "Chamarajanagar",
            "Chikkamagaluru",
            "Chikkaballapura",
            "Chitradurga",
            "Dakshina Kannada",
            "Davanagere",
            "Dharwad",
            "Gadag",
            "Hassan",
            "Haveri",
            "Kalaburagi",
            "Kodagu",
            "Kolar",
            "Koppal",
            "Mandya",
            "Mysuru",
            "Raichur",
            "Ramanagara",
            "Shimoga",
            "Tumkur",
            "Udupi",
            "Uttara Kannada",
            "Yadgir"
        ]
    },
    {
        name: "Kerala",
        districts: ["Alappuzha",
            "Ernakulam",
            "Idukki",
            "Kannur",
            "Kasaragod",
            "Kollam",
            "Kottayam",
            "Kozhikode",
            "Malappuram",
            "Palakkad",
            "Pathanamthitta",
            "Thrissur",
            "Wayanad"
        ]
    },
    {
        name: "Madhya Pradesh",
        districts: ["Agar Malwa",
            "Alirajpur",
            "Anuppur",
            "Ashok Nagar",
            "Balaghat",
            "Barwani",
            "Betul",
            "Bhind",
            "Bhopal",
            "Burhanpur",
            "Chhindwara",
            "Damoh",
            "Dewas",
            "Dhar",
            "Dindori",
            "Guna",
            "Gwalior",
            "Harda",
            "Hoshangabad",
            "Indore",
            "Jabalpur",
            "Jhabua",
            "Katni",
            "Khandwa",
            "Khargone",
            "Mandla",
            "Mandsaur",
            "Morena",
            "Narsinghpur",
            "Neemuch",
            "Panna",
            "Raisen",
            "Rajgarh",
            "Ratlam",
            "Rewa",
            "Sagar",
            "Satna",
            "Sehore",
            "Seoni",
            "Shahdol",
            "Shajapur",
            "Sheopur",
            "Shivpuri",
            "Sidhi",
            "Singrauli",
            "Tikamgarh",
            "Ujjain",
            "Umaria",
            "Vidisha"
        ]
    },
    {
        name: "Maharashtra",
        districts: ["Ahmednagar",
            "Akola",
            "Amravati",
            "Aurangabad",
            "Beed",
            "Bhandara",
            "Buldhana",
            "Chandrapur",
            "Dhule",
            "Gadchiroli",
            "Gondia",
            "Hingoli",
            "Jalgaon",
            "Jalna",
            "Kolhapur",
            "Latur",
            "Mumbai City",
            "Mumbai Suburban",
            "Nagpur",
            "Nanded",
            "Nandurbar",
            "Nasik",
            "Osmanabad",
            "Palghar",
            "Parbhani",
            "Pune",
            "Raigad",
            "Ratnagiri",
            "Satara",
            "Sindhudurg",
            "Solapur",
            "Thane",
            "Wardha",
            "Washim",
            "Yavatmal"
        ]
    },
    {
        name: "Manipur",
        districts: ["Bishnupur",
            "Churachandpur",
            "Imphal East",
            "Imphal West",
            "Jiribam",
            "Kakching",
            "Kamjong",
            "Kangpokpi",
            "Noney",
            "Pherzawl",
            "Senapati",
            "Tamenglong",
            "Tengnoupal",
            "Thoubal",
            "Ukhrul"
        ]
    },
    {
        name: "Meghalaya",
        districts: ["East Garo Hills",
            "East Khasi Hills",
            "Jaintia Hills",
            "Ri Bhoi",
            "West Garo Hills",
            "West Khasi Hills"
        ]
    },
    {
        name: "Mizoram",
        districts: ["Aizawl",
            "Champhai",
            "Hnahthial",
            "Kolasib",
            "Lawngtlai",
            "Lunglei",
            "Mamit",
            "Saiha",
            "Serchhip"
        ]
    },
    {
        name: "Nagaland",
        districts: ["Dimapur",
            "Kiphire",
            "Kohima",
            "Longleng",
            "Mokokchung",
            "Mon",
            "Phek",
            "Tuensang",
            "Wokha",
            "Zunheboto"
        ]
    },
    {
        name: "Odisha",
        districts: ["Angul",
            "Balangir",
            "Baleswar",
            "Bargarh",
            "Baudh",
            "Bhadrak",
            "Boudh",
            "Cuttack",
            "Deogarh",
            "Dhenkanal",
            "Gajapati",
            "Ganjam",
            "Jagatsinghpur",
            "Jajpur",
            "Jharsuguda",
            "Kalahandi",
            "Kandhamal",
            "Kendrapara",
            "Kendujhar",
            "Khurda",
            "Koraput",
            "Malkangiri",
            "Nabarangpur",
            "Nayagarh",
            "Nuapada",
            "Rayagada",
            "Sambalpur",
            "Subarnapur",
            "Sundargarh"
        ]
    },
    {
        name: "Punjab",
        districts: ["Amritsar",
            "Barnala",
            "Bathinda",
            "Fatehgarh Sahib",
            "Faridkot",
            "Ferozepur",
            "Jalandhar",
            "Kapurthala",
            "Ludhiana",
            "Mansa",
            "Moga",
            "Muktsar",
            "Patiala",
            "Rupnagar",
            "Sangrur",
            "Shaheed Bhagat Singh Nagar",
            "Sri Muktsar Sahib",
            "Tarn Taran"
        ]
    },
    {
        name: "Rajasthan",
        districts: ["Ajmer",
            "Alwar",
            "Banswara",
            "Baran",
            "Barmer",
            "Bhilwara",
            "Bikaner",
            "Bundi",
            "Chittorgarh",
            "Dungarpur",
            "Hanumangarh",
            "Jaipur",
            "Jaisalmer",
            "Jalore",
            "Jhalawar",
            "Jhunjhunu",
            "Jodhpur",
            "Karauli",
            "Kota",
            "Nagaur",
            "Pali",
            "Rajasthan",
            "Sawai Madhopur",
            "Sikar",
            "Sirohi",
            "Tonk",
            "Udaipur"
        ]
    },
    {
        name: "Sikkim",
        districts: ["East Sikkim",
            "North Sikkim",
            "South Sikkim",
            "West Sikkim"]
    },
    {
        name: "Tamil Nadu",
        districts: ["Chennai",
            "Coimbatore",
            "Cuddalore",
            "Dharmapuri",
            "Dindigul",
            "Erode",
            "Kancheepuram",
            "Kanyakumari",
            "Karur",
            "Madurai",
            "Nagapattinam",
            "Namakkal",
            "Perambalur",
            "Pudukottai",
            "Ramanathapuram",
            "Salem",
            "Sivaganga",
            "Tenkasi",
            "Thanjavur",
            "Theni",
            "Tiruchirappalli",
            "Tirunelveli",
            "Tirupathur",
            "Tiruppur",
            "Tiruvallur",
            "Tiruvannamalai",
            "Vellore",
            "Viluppuram",
            "Virudhunagar"]
    },
    {
        name: "Telangana",
        districts: ["Adilabad",
            "Bhadradri Kothagudem",
            "Hyderabad",
            "Jagtial",
            "Jangaon",
            "Jayashankar Bhoopalpally",
            "Jogulamba Gadwal",
            "Kamareddy",
            "Karimnagar",
            "Khammam",
            "Mahabubabad",
            "Mahabubnagar",
            "Mancherial",
            "Medak",
            "Medchal Malkajgiri",
            "Nalgonda",
            "Nirmal",
            "Nizamabad",
            "Peddapalli",
            "Rajanna Sircilla",
            "Ranga Reddy",
            "Sangareddy",
            "Vikarabad",
            "Warangal (Rural)",
            "Warangal (Urban)",
            "Yadadri Bhuvanagiri"
        ]
    },
    {
        name: "Tripura",
        districts: ["Dhalai",
            "Khowai",
            "North Tripura",
            "South Tripura",
            "Unakoti",
            "West Tripura"
        ]
    },
    {
        name: "Uttar Pradesh",
        districts: ["Agra",
            "Aligarh",
            "Ambedkar Nagar",
            "Amethi",
            "Amroha",
            "Auraiya",
            "Ayodhya",
            "Baghpat",
            "Bahraich",
            "Ballia",
            "Balrampur",
            "Banda",
            "Bara Banki",
            "Bareilly",
            "Basti",
            "Bijnor",
            "Budaun",
            "Bulandshahr",
            "Chandauli",
            "Chhatrapati Shahuji Maharaj Nagar",
            "Etah",
            "Etawah",
            "Faizabad",
            "Farrukhabad",
            "Fatehpur",
            "Firozabad",
            "Gautam Buddha Nagar",
            "Ghaziabad",
            "Ghazipur",
            "Gonda",
            "Gorakhpur",
            "Hamirpur",
            "Hapur",
            "Hardoi",
            "Hathras",
            "Jalaun",
            "Jaunpur",
            "Jhansi",
            "Kannauj",
            "Kanpur Dehat",
            "Kanpur Nagar",
            "Kasganj",
            "Kaushambi",
            "Kushinagar",
            "Lakhimpur Kheri",
            "Lalitpur",
            "Lucknow",
            "Maharajganj",
            "Mahoba",
            "Mainpuri",
            "Mathura",
            "Mau",
            "Meerut",
            "Mirzapur",
            "Moradabad",
            "Muzaffarnagar",
            "Pilibhit",
            "Pratapgarh",
            "Raebareli",
            "Rajnagar",
            "Rampur",
            "Saharanpur",
            "Sant Kabir Nagar",
            "Shahjahanpur",
            "Shamli",
            "Shravasti",
            "Siddharthnagar",
            "Sitapur",
            "Sonbhadra",
            "Sultanpur",
            "Unnao",
            "Varanasi"
        ]
    },
    {
        name: "Uttarakhand",
        districts: [  "Almora",
            "Bageshwar",
            "Bharatpur",
            "Chamoli",
            "Champawat",
            "Dehradun",
            "Haridwar",
            "Nainital",
            "Pauri Garhwal",
            "Pithoragarh",
            "Rudraprayag",
            "Tehri Garhwal",
            "Udham Singh Nagar",
            "Uttarkashi"
        ]
    },
    {
        name: "West Bengal",
        districts: [  "Alipurduar",
            "Bankura",
            "Bardhaman",
            "Birbhum",
            "Dakshin Dinajpur",
            "Darjeeling",
            "Hooghly",
            "Howrah",
            "Jalpaiguri",
            "Jhargram",
            "Kalimpong",
            "Kolkata",
            "Maldah",
            "Murshidabad",
            "Nadia",
            "North 24 Parganas",
            "Paschim Bardhaman",
            "Paschim Medinipur",
            "Purba Bardhaman",
            "Purba Medinipur",
            "Purulia",
            "South 24 Parganas",
            "Uttar Dinajpur"
        ]
    },
    {
        name: "Puducherry",
        districts: ["Puducherry", "Karaikal", "Mahe", "Yanam"]
    }
];

